import React, { useState, useEffect } from "react";
import "./graphicData.css";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const GraphicData = ({ time, type, data }) => {
  const [timeReceived, setTimeReceived] = useState("Cargando...");
  const [title, setTitle] = useState("Cargando...");
  const [color, setColor] = useState();
  
  useEffect(() => {
    validateData();
  }, []);

  function validateData() {
    switch (time) {
      case "day":
        setTimeReceived("Hoy");
        break;
      case "week":
        setTimeReceived("Última semana");
        break;
      case "month":
        setTimeReceived("Mes");
        break;
      default:
        setTimeReceived("Total");
    }

    switch (type) {
      case "eja":
        setColor("var(--blue)");
        setTitle("Enlace Jurídico Académico");
        break;
      case "opinio":
        setColor("var(--gold)");
        setTitle("Resvista Opinio Iuris");
        break;
      default:
        setColor("var(--red)");
        setTitle("Total");
    }
  }

  return (
    <div className="graphicData p-2">
      <div className="row d-flex justify-content-center">
        <div className="col-12">
          <div className="card-title">
            <h5 className="font-bebas color-azul">
              <span>{timeReceived}</span>
            </h5>
          </div>
        </div>
        <div className="col-12 progress-circular px-5 py-3">
          <CircularProgressbarWithChildren
            value={data}
            styles={buildStyles({
              trailColor: "var(--green)",
              pathColor: color,
            })}
          >
            {data === "empty" ? (
              <div><p className="graphic__title">Aún no hay visitas</p></div>
            ) : (
              <>
                  <p className="graphic__title">
                    {title}: {data}
                  </p>
              </>
            )}
          </CircularProgressbarWithChildren>
        </div>
      </div>
    </div>
  );
};

export default GraphicData;
